import React, { useState, useEffect } from 'react';
import {
  Box, DialogContent, DialogActions, Button, CircularProgress,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../common/dialog/BootstrapDialog';
import * as chanceApi from '../../lib/api/chance';
import { isNativeApp, openPdfNatively } from '../../lib/nativeDownload';

const EstimatePreviewModal = ({ open, handleClose, chanceId, qteUuid, qteNo }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!open || !qteUuid) return;

    const loadPdf = async () => {
      setLoading(true);
      try {
        const res = await chanceApi.downloadQuotePdf(qteUuid);
        const blob = new Blob([res.data], { type: 'application/pdf' });
        // 네이티브(Android) 앱: WebView가 iframe으로 PDF를 못 그리므로 미리보기 Dialog를
        // 띄우는 대신 폰의 PDF 뷰어로 바로 열고 이 Dialog는 닫는다.
        if (isNativeApp()) {
          await openPdfNatively(blob, `견적서_${qteNo || 'estimate'}.pdf`);
          handleClose();
          return;
        }
        const url = window.URL.createObjectURL(blob);
        setPdfUrl(url);
      } catch (err) {
        console.error('PDF 로드 실패:', err);
        if (isNativeApp()) {
          enqueueSnackbar('PDF 미리보기 실패: ' + (err?.message || err), { variant: 'error' });
        }
      } finally {
        setLoading(false);
      }
    };
    loadPdf();

    return () => {
      if (pdfUrl) {
        window.URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [open, qteUuid]);

  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = '견적서.pdf';
      link.click();
    }
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="lg"
    >
      <BootstrapDialogTitle onClose={handleClose}>
        견적서 미리보기
      </BootstrapDialogTitle>
      <DialogContent dividers sx={{ height: '80vh', p: 0 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </Box>
        ) : pdfUrl ? (
          <iframe
            src={pdfUrl}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="견적서 PDF 미리보기"
          />
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'text.secondary' }}>
            PDF를 불러올 수 없습니다.
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="warning" onClick={handleDownload} disabled={!pdfUrl}>
          PDF 다운로드
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default EstimatePreviewModal;
